$(document).on("turbolinks:load", () => {
  const SCHEDULING_ID = "add_scheduling_information";
  const SELECT_RECURRING_PERIOD_ID = "#recurrence_period";
  const NEVER_STOP_ID = "#never-stop";
  const UNTIL = "until";
  const AFTER = "after";
  const RECURRING_UNTIL_ID = "#recurring_until";
  const MAX_ITERATIONS_ID = "#max_iterations";
  const WEEKDAYS_COMPONENT_ID = "#weekdays_component";
  const WEEKDAYS_NAME = "template[weekdays][]";
  const HIDDEN_FIELDS_WEEKDAYS = "#hidden_field_weekdays";
  const WEEKDAYS_BUTTON_DOM = ".weekdays-btn-group.btn-primary";

  function toggleWeekdaysComponent(value: string) {
    if (value === "week") {
      $(WEEKDAYS_COMPONENT_ID).show();
      // insert selected days as hidden fields
      Array.from(document.querySelectorAll(`${WEEKDAYS_BUTTON_DOM}`)).forEach((item) => {
        const { paramName, paramValue } = (item as HTMLElement).dataset;
        $(HIDDEN_FIELDS_WEEKDAYS).append(`<input type='hidden' value="${paramValue}" name="${paramName}">`);
      });
      $(`input[type="hidden"][name="${WEEKDAYS_NAME}"][value="[]"]`).remove();
    } else {
      $(WEEKDAYS_COMPONENT_ID).hide();
      // remove selected days hidden fields
      Array.from(document.querySelectorAll(`input[type="hidden"][name="${WEEKDAYS_NAME}"]`)).forEach((item) => item.remove());
      // add empty array
      $(HIDDEN_FIELDS_WEEKDAYS).append(`<input type='hidden' value="[]" name="${WEEKDAYS_NAME}">`);
    }
  }

  if (document.getElementById(SCHEDULING_ID)) {
    // init
    toggleWeekdaysComponent($(SELECT_RECURRING_PERIOD_ID).val() as string);

    $(SELECT_RECURRING_PERIOD_ID).change((e) => {
      toggleWeekdaysComponent((e.target as HTMLInputElement).value);
    });

    // recurring choices (radios
    $(NEVER_STOP_ID).change(() => {
      $(RECURRING_UNTIL_ID).val("");
      $(MAX_ITERATIONS_ID).val("");
    });

    $(`#${UNTIL}`).change(() => {
      $(MAX_ITERATIONS_ID).val("");
    });

    $(`#${AFTER}`).change(() => {
      $(RECURRING_UNTIL_ID).val("");
    });

    $(RECURRING_UNTIL_ID).change(() => {
      $(MAX_ITERATIONS_ID).val("");
      $(`input[type=radio][id=${UNTIL}]`).prop("checked", true);
    });

    $(MAX_ITERATIONS_ID).change(() => {
      $(RECURRING_UNTIL_ID).val("");
      $(`input[type=radio][id=${AFTER}]`).prop("checked", true);
    });

  }
});
